import {RemoteGetProcedureMedicalGuideV3} from 'data/usecases/private/guide-flow/medical-guide/remote-get-procedure-v3';
import {GetProcedureMedicalGuideV3} from 'domain/usecases/private/guide-flow/medical-guide/get-procedure-v3';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetProcedureMedicalGuideV3 = (): GetProcedureMedicalGuideV3 =>
	new RemoteGetProcedureMedicalGuideV3(
		makeBFFApiUrl(GuideFlowEndpoints.medicalGuideProcedureV3),
		makeAuthorizeHttpClientDecorator(),
	);
